import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataHelper } from '@app/helpers/data.helper';
import { DataService } from '@app/services/data.service';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'freebet-info-modal',
  templateUrl: '../sharedTemplates/freebet-info-modal.html',
})
export class FreeBetInfoModal {
  constructor(
    public _DataHelper: DataHelper,
    public dialogRef: MatDialogRef<FreeBetInfoModal>,
    private _DataService: DataService,
    private router: Router,
    private _UiHelper: UiHelper,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this._UiHelper.closeAllMenus();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  setFreeBetCheckBox() {
    this._DataHelper.freebetBonusCheckBox = true;
    this._DataService.fireApiCall('getCurrentSlipAmount');
    this._DataService.fireApiCall('refreshCurrentSlip');
    this.dialogRef.close();
  }
  openInNewTab(url: string): void {
    window.open(this.router.serializeUrl(this.router.createUrlTree([url])), '_blank');
  }
}
